import { render } from "./MarketingPage.vue?vue&type=template&id=575b00e8"
import script from "./MarketingPage.vue?vue&type=script&lang=js"
export * from "./MarketingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__